module.exports = __webpack_public_path__ + "img/180ea54d5ac4e82ae653af02d523e79d.png";